module.exports = __webpack_public_path__ + "img/quotysco.1ca40463.png";